export default "__VITE_ASSET__6iRxFE2o__"